import { makeStyles } from "@material-ui/core/styles";
import imgTransparent from "../../../images/preference/transparent.png";
import { Backdrop } from "@material-ui/core";
import { ChromePicker } from "react-color";
import { useBoolean } from "../../../hooks/useBoolean";
import { useEffect, useState } from "react";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
  colorBox: {
    position: "relative",
    width: 50,
    height: 20,
    border: '1px solid #d9d9d9',
    background: `url(${imgTransparent}) repeat`,
    cursor: 'pointer',
  },
  colorBoxInner: {
    width: '100%',
    height: '100%',
  },
  backdrop: {
    zIndex: theme.zIndex.modal + 1,
    backgroundColor: 'transparent'
  },
  cursorDefault: {
    cursor: 'default'
  }
}));

const ColorBox = ({color, onClick, onChange, disabled}) => {
  const [targetColor, setTargetColor] = useState(color)
  const [openPicker, showPicker, closePicker] = useBoolean(false);
  const classes = useStyles();

  useEffect(() => {
    setTargetColor(color);
  }, [color]);

  const handleClickColorBox = () => {
    if (disabled) return;
    showPicker();
    if (onClick) {
      onClick(targetColor);
    }
  };

  const handleChangeComplete = (color) => {
    const rgba = `rgba(${color.rgb.r},${color.rgb.g},${color.rgb.b},${color.rgb.a})`
    setTargetColor(rgba);
    if (onChange) {
      onChange(rgba);
    }
  }

  const handlePickerClose = event => {
    if (event.target === event.currentTarget) {
      closePicker()
    }
  };

  return (
    <>
      <div className={clsx(classes.colorBox, disabled && classes.cursorDefault)} onClick={handleClickColorBox}>
        <div className={classes.colorBoxInner} style={{backgroundColor: targetColor}}/>
      </div>
      {openPicker &&
        <Backdrop open={openPicker} onClick={handlePickerClose} className={classes.backdrop}>
          <ChromePicker
            color={targetColor}
            onChangeComplete={handleChangeComplete}
          />
        </Backdrop>
      }
    </>
  )
};

export default ColorBox;